<div class="sidebar" [ngStyle]="{'width': IsSidebarOpen ? '260px' : '0'}">
    <div id="MainMenu">
        <ul class="list-group panel sidebarul">
            <ng-container *ngFor="let menu of dynamicMenu">
                <li>
                    <a *ngIf="menu.submenu.length==0" [routerLink]="[menu.routerLink]"
                        class="list-group-item list-group-item-success">
                        <!-- <span [ngClass]="menu.icon"></span> -->
                        <span class="material-icons">{{menu.icon}}</span>
                        <span>{{menu.name}}</span>
                    </a>
                    <mat-expansion-panel [attr.role]="null" *ngIf="menu.submenu.length > 0" class="mat-elevation-z0">
                        <mat-expansion-panel-header [attr.role]="null" class="pl-0">
                            <mat-panel-title class="list-group-item list-group-item-success">
                                <span class="material-icons">{{menu.icon}}</span>
                                <span>{{menu.name}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="nav-section">
                            <div *ngFor="let subMenu of menu.submenu" class="nav-item">
                                <a [routerLink]="subMenu.routerLink" class="list-group-item list-group-item-success"
                                    routerLinkActive="selected">
                                    <!-- <span [ngClass]="subMenu.icon"></span> -->
                                    <span class="material-icons tiny">{{subMenu.icon}}</span>
                                    <span>{{subMenu.name}}</span>
                                </a>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </li>
            </ng-container>
        </ul>
    </div>
</div>